import {Observable, Subscription} from 'rxjs';

import IPlaybackStore from '../Interfaces/IPlaybackStore';

const subscribeToRewindTap = (
    rewindTap$: Observable<void>,
    playbackStore: IPlaybackStore
): Subscription =>
    rewindTap$
        .subscribe(() => playbackStore.actions.rewind());

export default subscribeToRewindTap;